
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.747 24.004a.748.748 0 01-.53-.219.746.746 0 01-.163-.82l3.06-7.327a.695.695 0 01.081-.145l.031-.04a.444.444 0 01.047-.054L13.852 4.826l.027-.031a.579.579 0 01.044-.039l3.035-3.035A2.235 2.235 0 0016 1.509c-.601 0-1.164.232-1.587.655l-3.186 3.182a.748.748 0 01-1.061-.001.751.751 0 01.001-1.061l3.186-3.182A3.722 3.722 0 0116.004.007c.759 0 1.501.231 2.121.655a3.871 3.871 0 012.138-.647c.761 0 1.5.223 2.135.646a3.75 3.75 0 011.542 2.443 3.722 3.722 0 01-1.041 3.276L8.58 20.7a.429.429 0 01-.045.038.712.712 0 01-.194.123L1.04 23.946a.762.762 0 01-.293.058zm1.4-2.155l4.584-1.937-2.663-2.663-1.921 4.6zm5.902-2.74l9.546-9.546-3.18-3.18-9.547 9.544 3.181 3.182zM18.656 8.503l3.182-3.182a2.252 2.252 0 00-.29-3.424 2.322 2.322 0 00-1.284-.384c-.642 0-1.265.267-1.71.732l-3.078 3.077 3.18 3.181z"}})])
          )
        }
      }
    